const pauseOnFunctions = localStorage.getItem('pauseOnFunctions') || '';
const showOnlyThisEvents = localStorage.getItem('showOnlyThisEvents') || '';
const configDev = {
	debug_key: 'debug',
	debug: localStorage.getItem('debug') === 'true',
	pause: localStorage.getItem('debugPause') === 'true',
	pauseOnFunctions: pauseOnFunctions.split(',') || [],
	showOnlyThisEvents: showOnlyThisEvents.split(',') || [],
};

const debbuger = (config, data, deletePrevious = false) => {
  let _text, _type;
  const icons = {
    error: "💣",
    warn: "☔",
    log: "⌛",
    info: "💻",
  };
  const bg = {
    error: "#b15b00",
    warn: "#cce019",
    log: "#b15b00",
    info: "#59ab5d",
  };

  if(config && typeof config === "object") {
    const { type, text } = config;
    _text = text;
    _type = type;
  } else if(typeof config === "string") {
    _text = config;
  }

  if(deletePrevious) {
    console.clear()
  }

  if (configDev.debug && (!showOnlyThisEvents.length || configDev.showOnlyThisEvents.includes(_text))) {
    console[_type || "info"](
      `%c ${_text} ${icons[_type || "info"]}`,
      `background: ${bg[_type || "info"]}; color: #ffffff; font-size: 18px`,
      data
    );

    if(configDev.pause && configDev.pauseOnFunctions.includes(_text)) {
      debugger;
    }
  }
};


window.smkDevUtils = {
	debbuger,
	config: configDev
};